export default __webpack_public_path__ + "static/media/Achiton of Effulgent Devotion.813aadce.jpg";